export const COMPANY_NAME = "J3 Chandar LLC";
export const COMPANY_SHORT = "J3 Chandar";
export const COMPANY_INITIALS = "JC";
export const COMPANY_ADDRESS_FULL = "516 Bouma Ln, Ripon, CA 95366";
export const COMPANY_LOCATION = "Ripon, CA";
export const COMPANY_REGION = "San Joaquin County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=516%20Bouma%20Ln%2C%20Ripon%2C%20CA%2095366";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "J3 Chandar LLC" },
  { "label": "Location", "value": "Ripon, California" },
  { "label": "Region", "value": "San Joaquin County" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "J3 Chandar LLC" },
  { "label": "City & state", "value": "Ripon, California" },
  { "label": "Listed address", "value": "516 Bouma Ln, Ripon, CA 95366" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Public profile", "body": "A concise directory profile built from the organization name and public address." },
  { "icon": "✦", "title": "Location details", "body": "Find the listed Ripon address and open it directly in maps." },
  { "icon": "✿", "title": "Directory information", "body": "This profile presents only general public-record details." },
  { "icon": "❍", "title": "More information", "body": "Additional organization details can be added when verified public information is available." },
];
